import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18next from 'i18next';

import { Rail, RailContainer } from 'components/Rail';
import MidresponsiveAd from 'components/Ad/Midresponsive';

import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';
import { getFirstPackageFromPackages, packageHasTitleOrType } from 'lib/packageHelper';
import { LAYOUT_7_LEFT_COLUMNS_AT_LARGE_BREAKPOINT } from 'lib/brandFeatures.json';
import * as CustomPropTypes from 'lib/CustomPropTypes';
import $t from 'lib/trackingService';
import Breakpoints from 'lib/Breakpoints';
import BTE from 'lib/BTE';

import getPackagesForZone from '../getPackagesForZone';

const LATEST_STORIES_TRACKING_ID = 'mbt_rightRailTabbed_latestClick';

class RightRailTabbed extends Component {
  static propTypes = {
    packages: PropTypes.arrayOf(CustomPropTypes.package).isRequired,
  };

  static contextTypes = {
    ...CustomPropTypes.layoutContext,
  };

  constructor(props) {
    super(props);
    this.state = {
      tabbed: true,
      contentTab: true,
      railTab: false,
      contentScroll: 0,
      railScroll: 0,
    };
  }

  componentDidMount() {
    this.setTabs();

    this.setInitialTabScroll();

    $t('register', LATEST_STORIES_TRACKING_ID);

    BTE.monitorResize();
    BTE.on('resize', this.onResize);

    const { vertical } = this.context;
    // eslint-disable-next-line max-len
    this.has7LeftColumnsAtLargeBreakpoint = getFeatureConfigForBrand(LAYOUT_7_LEFT_COLUMNS_AT_LARGE_BREAKPOINT, vertical);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      tabbed, contentTab, railTab, contentScroll, railScroll,
    } = this.state;

    if (!tabbed) {
      return;
    }

    if (contentTab && prevState.contentTab !== contentTab) {
      window.scrollTo(0, contentScroll);
    }

    if (railTab && prevState.railTab !== railTab) {
      window.scrollTo(0, railScroll);
    }
  }

  onResize = () => {
    this.setTabs();
  };

  setInitialTabScroll() {
    const containerTop = this.container.offsetTop - 50;

    this.setState({ contentScroll: containerTop, railScroll: containerTop });
  }

  setTabs() {
    this.setState({ tabbed: !Breakpoints.isLorXL() });
  }

  changeTab(tab) {
    const { pageYOffset: scrollY } = window;

    if (tab === 'content') {
      this.setState({ contentTab: true, railTab: false, railScroll: scrollY });
    } else {
      $t('track', LATEST_STORIES_TRACKING_ID);
      this.setState({ contentTab: false, railTab: true, contentScroll: scrollY });
    }
  }

  tabTitle() {
    const { packages } = this.props;
    const teaseList = packages.find((pkg) => pkg.type && pkg.type === 'teaseList');

    if (teaseList && teaseList.metadata && teaseList.metadata.title) {
      return teaseList.metadata.title;
    }

    return 'Latest';
  }

  tabs() {
    const { tabbed, contentTab, railTab } = this.state;
    const showContentTab = !tabbed || (tabbed && contentTab);
    const showRailTab = !tabbed || (tabbed && railTab);

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <div
        className={classNames(
          'right-rail-tabbed__tabs',
          { 'right-rail-tabbed__tabs--visible': tabbed },
        )}
      >
        <div
          className={classNames(
            'right-rail-tabbed__tab',
            { 'right-rail-tabbed__tab--active': showContentTab },
          )}
          onClick={() => { this.changeTab('content'); }}
        >
          {`${i18next.t('Top Stories')}`}
        </div>
        <div
          className={classNames(
            'right-rail-tabbed__tab',
            { 'right-rail-tabbed__tab--active': showRailTab },
          )}
          onClick={() => { this.changeTab('rail'); }}
        >
          {this.tabTitle()}
        </div>
      </div>
    );
    /* eslint-enable jsx-a11y/click-events-have-key-events */
    /* eslint-enable jsx-a11y/no-static-element-interactions */
  }

  render() {
    const { packages } = this.props;
    const { tabbed, contentTab, railTab } = this.state;

    const showContentTab = !tabbed || (tabbed && contentTab);
    const showRailTab = !tabbed || (tabbed && railTab);
    const firstPackageHasTitleOrIsPancake = packageHasTitleOrType(getFirstPackageFromPackages(packages), 'pancake');
    const containerClasses = classNames({
      'layout-grid-container': true,
      'right-rail-tabbed__has-title-is-pancake': showContentTab && firstPackageHasTitleOrIsPancake,
    });
    const leftGridClasses = this.has7LeftColumnsAtLargeBreakpoint ? 'grid-col-7-l grid-col-8-xl' : 'grid-col-8-l grid-col-9-xl';
    const rightGridClasses = this.has7LeftColumnsAtLargeBreakpoint ? 'grid-col-5-l grid-col-4-xl' : 'grid-col-4-l grid-col-3-xl';
    const leftClasses = classNames(`right-rail-tabbed__container--left layout-grid-item ${leftGridClasses}`);
    const rightClasses = classNames(`layout-grid-item ${rightGridClasses}`);
    return (
      <div className="layout-rightRailTabbed" ref={(el) => { this.container = el; }}>
        {this.tabs()}

        <RailContainer className={containerClasses}>
          {showContentTab && (
            <div className={leftClasses}>
              {
                getPackagesForZone(1, packages, { ...this.context, isRailAdjacent: true })
              }
            </div>
          )}
          {showRailTab && (
            <Rail className={rightClasses}>
              {getPackagesForZone(2, packages, { ...this.context, railContext: 'right' })}
            </Rail>
          )}
        </RailContainer>

        <MidresponsiveAd />
      </div>
    );
  }
}

export default RightRailTabbed;
